import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	Output,
	SimpleChanges,
} from '@angular/core';
import { DateTime } from 'luxon';

import { IEvaluationDetail } from './../../interfaces/evaluations.interface';
import { EvaluationsService } from './../../services/evaluations.service';

@Component({
	templateUrl: './evaluation-answer-detail.component.html',
	selector: 'evaluation-answer-detail',
	styleUrls: ['evaluation-answer-detail.component.scss'],
})
export class EvaluationAnswerDetailComponent implements OnChanges {
	@Input() isOpen;
	@Input() evaluationId;
	@Input() contactId;
	@Output('closeModal') emClosedSidebar = new EventEmitter();
	isLoading = true;
	hasError = false;
	evaluationDetail: IEvaluationDetail;

	constructor(private evaluationsService: EvaluationsService) {}

	ngOnChanges(changes: SimpleChanges) {
		if (!changes.isOpen?.firstChange && changes.isOpen?.currentValue) {
			this.evaluationsService
				.getEvaluationById(this.contactId, this.evaluationId)
				.toPromise()
				.then((res) => {
					this.evaluationDetail = res;
				})
				.catch(() => {
					this.hasError = true;
				})
				.finally(() => {
					this.isLoading = false;
				});
		}
	}

	formatedDate(date) {
		return DateTime.fromISO(date).setLocale('pt-br').toFormat('dd/LL/yyyy');
	}
}
